<template>
	<div class="minbar">
		<!--底部导航栏 -->
		<van-tabbar v-model="active" replace :route="route" inactive-color="#222222" active-color="#f24d38" :z-index="2020">
			<van-tabbar-item icon="home-o" to="/Home">首页</van-tabbar-item>
			<van-tabbar-item icon="search" to="/Brand">找厂家</van-tabbar-item>
			<van-tabbar-item icon="after-sale" to="/Offline">收付款</van-tabbar-item>
			<van-tabbar-item icon="shopping-cart-o" to="/Carts">购物车</van-tabbar-item>
			<van-tabbar-item icon="contact" to="/Min">我的</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
	export default {
		name: 'MinBar',
		data() {
			return {
				active: 0,
				route: true
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/minBar.vue